// TODO: move to enums(files in scope of feature should be grouped by type) + this enum difficult to find due to file name
export enum PageRoute {
  MAIN = '/',
  VRS_IN_CENTER_TEAMING_NOTICE = '/vrs/in-center-teaming-notice',
  VRS_TEAMING_LOGOUT_NOTICE = '/vrs/teaming-logout-notice',
  VRI_CALL = '/vri/call',
  VRS_CALL = '/vrs/call',
  VRI_CONFERENCE = '/vri/conference',
  VRS_CONFERENCE = '/vrs/conference',
  ZOOM_VRS = '/zoom-vrs',
  ZOOM_VRI = '/zoom-vri',
  SOMETHING_WENT_WRONG = '/something-went-wrong',
  ACCESS_DENIED = '/access-denied',
  REPORT_PREVIOUS_CALL = '/report-previous-call',
}
